'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { OpenPaymentsNoticeContent } from './open-payments-notice-content.component';
import { useOpenPaymentsNotice } from './use-open-payments-notice.hook';

export function OpenPaymentsNoticePopover() {
  const { isRendered } = useOpenPaymentsNotice('popover');

  if (!isRendered) {
    return null;
  }

  return (
    <div
      role="status"
      className="absolute right-[-8.5px] top-full z-10 mt-[11px] w-[484px] max-w-[calc(100vw-2rem)]"
      data-testid={DataTestIdEnum.OPEN_PAYMENTS_NOTICE}
    >
      <div className="flex items-center gap-3 rounded-2xl border border-warning-300 bg-warning-100 p-[11px] shadow-floating">
        <OpenPaymentsNoticeContent />
      </div>

      <span
        aria-hidden="true"
        className="absolute right-[19px] top-0 z-10 size-[11px] -translate-y-1/2 rotate-45 border-l border-t border-warning-300 bg-warning-100"
      />
    </div>
  );
}
